import { render, staticRenderFns } from "./ProvidersReact.vue?vue&type=template&id=228c60e8&"
import script from "./ProvidersReact.vue?vue&type=script&lang=js&"
export * from "./ProvidersReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports